export default __webpack_public_path__ + "static/media/HAY.c694677d.svg";